import PropTypes from 'prop-types';
import Image from '@components/image';
import Button from '@components/button';

import { more_button, info_container } from '../styles.module.scss';

const StepTwo = ({ photos, address, openHouse, setModalIsOpen }) => {
  return (
    <>
      <div className={info_container}>
        <h2>Thank You! Enjoy!</h2>
        <Image
          image={{ height: 122, src: photos[0].midSizeImageUrl, width: 250 }}
          alt={photos[0].title}
        />
        <h3>{address}</h3>
        <p>{openHouse}</p>
      </div>

      <Button
        className={more_button}
        onClick={() => setModalIsOpen(false)}
        label="More about this listing"
        theme="red-text-only-with-caret"
      />
    </>
  );
};

StepTwo.propTypes = {
  directionsUrl: PropTypes.string,
  photos: PropTypes.array,
  address: PropTypes.string,
  openHouse: PropTypes.string,
  setModalIsOpen: PropTypes.funcq
};

export default StepTwo;
